import React from 'react';
import PropTypes from 'prop-types';
import Textarea from '@client/components/formComponents/textarea/Textarea';
import styles from './styles.scss';

const TextareaGroup = React.memo(
  ({
    className,
    textareaClassName,
    formLabelClassName,
    errorTextClassName,
    labelText,
    name,
    value,
    onChange,
    onBlur,
    autoComplete,
    isDisabled,
    readOnly,
    rows,
    cols,
    maxLength,
    tabIndex,
    defaultValue,
    errorLabel,
    placeholder,
  }) => {
    return (
      <div
        className={`${styles.textareaGroup}${className ? ` ${className}` : ''}`}
      >
        <label
          className={`${styles.formLabel}${
            formLabelClassName ? ` ${formLabelClassName}` : ''
          }`}
        >
          {labelText}
        </label>
        <Textarea
          placeholder={placeholder}
          className={`${textareaClassName}`}
          disabled={isDisabled}
          readOnly={readOnly}
          autoComplete={autoComplete}
          rows={rows}
          cols={cols}
          maxLength={maxLength}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          defaultValue={defaultValue}
          tabIndex={tabIndex}
        />
        {errorLabel && (
          <span
            className={`${styles.errorText}${
              errorTextClassName ? ` ${errorTextClassName}` : ''
            }`}
          >
            {errorLabel}
          </span>
        )}
      </div>
    );
  }
);

TextareaGroup.displayName = 'TextareaGroup';

TextareaGroup.propTypes = {
  className: PropTypes.string,
  textareaClassName: PropTypes.string,
  formLabelClassName: PropTypes.string,
  errorTextClassName: PropTypes.string,
  labelText: PropTypes.string,
  name: PropTypes.string,
  isDisabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.string,
  autoComplete: PropTypes.string,
  rows: PropTypes.number,
  cols: PropTypes.number,
  maxLength: PropTypes.number,
  tabIndex: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  errorLabel: PropTypes.string,
  placeholder: PropTypes.string,
};

export default TextareaGroup;
